// src/store/reducers/productSlice.js
import { createSlice } from '@reduxjs/toolkit';

const productSlice = createSlice({
  name: 'products',
  initialState: {
    loading: false,
    displayMirrors: [], // 镜像站展示产品
    displayFinished: [], // 成品号展示产品
    allMirrors: [], // 所有镜像站产品
    allFinished: [], // 所有成品号产品
    productDetail: null, // 具体产品详情
    error: null,
    order: null, // 新增：订单信息
    orderLoading: false, // 新增：订单加载状态
    orderError: null, // 新增：订单错误信息
  },
  reducers: {
    fetchProductsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchMirrorDisplaySuccess(state, action) {
      state.loading = false;
      state.displayMirrors = action.payload;
    },
    fetchFinishedDisplaySuccess(state, action) {
      state.loading = false;
      state.displayFinished = action.payload;
    },
    fetchAllMirrorsSuccess(state, action) {
      state.loading = false;
      state.allMirrors = action.payload;
    },
    fetchAllFinishedSuccess(state, action) {
      state.loading = false;
      state.allFinished = action.payload;
    },
    fetchProductDetailSuccess(state, action) {
      state.loading = false;
      state.productDetail = action.payload;
    },
    fetchProductsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // 新增：订单相关的 reducer
    createOrderRequest(state) {
      state.orderLoading = true;
      state.orderError = null;
    },
    createOrderSuccess(state, action) {
      state.orderLoading = false;
      state.order = action.payload;
    },
    createOrderFailure(state, action) {
      state.orderLoading = false;
      state.orderError = action.payload;
    },
  },
});

export const {
  fetchProductsRequest,
  fetchMirrorDisplaySuccess,
  fetchFinishedDisplaySuccess,
  fetchAllMirrorsSuccess,
  fetchAllFinishedSuccess,
  fetchProductDetailSuccess,
  fetchProductsFailure,
  createOrderRequest, // 新增
  createOrderSuccess, // 新增
  createOrderFailure, // 新增
} = productSlice.actions;

export default productSlice.reducer;